import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { State, getCurrentUserState } from '®app/ngrx/state';
import {
  AuthService,
  AuthorizationHeaderJson,
  EffectiveUserHeaderJson,
} from '®shared/auth';

import { CurrentUserAndPermissions } from './current-user-and-permissions';
import {
  LogInAction,
  LogInDuringRouteNavigationAction,
  LogOutAction,
  RequestCurrentUserAction,
} from './current-user.actions';

@Injectable()
export class CurrentUserService {
  constructor(private authService: AuthService, private store: Store<State>) {}

  getCurrentUser(): Observable<CurrentUserAndPermissions> {
    return this.store.select(getCurrentUserState).pipe(
      map(state => state.loadableUser),
      tap(loadableUser => {
        // if no user already requested, request the current user
        if (!loadableUser || (!loadableUser.data && !loadableUser.isLoading)) {
          this.store.dispatch(new RequestCurrentUserAction());
        }
      }),
      filter(user => (user && user.data ? true : false)),
      map(user => user.data),
      first(),
    );
  }

  login(): void {
    this.store.dispatch(new LogInAction());
  }

  loginDuringNavigation(stateUrl: string): void {
    this.store.dispatch(new LogInDuringRouteNavigationAction({ stateUrl }));
  }

  logout(): void {
    this.store.dispatch(new LogOutAction());
  }

  getCurrentUserGuid(): string | null {
    const oauthUser = this.authService.currentUser;
    return oauthUser.isAnonymous ? null : oauthUser.guid;
  }

  getSessionId(): string {
    return this.authService.sessionId;
  }

  getBearerHeader(): AuthorizationHeaderJson | undefined {
    return this.authService.getBearerHeader();
  }

  getUserHeader(): EffectiveUserHeaderJson | undefined {
    return this.authService.getUserHeader();
  }
}
